import { render, staticRenderFns } from "./submitted.vue?vue&type=template&id=320feaee&scoped=true"
import script from "./submitted.vue?vue&type=script&lang=js"
export * from "./submitted.vue?vue&type=script&lang=js"
import style0 from "./submitted.vue?vue&type=style&index=0&id=320feaee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320feaee",
  null
  
)

export default component.exports